import React, { useEffect } from 'react';
import { Box, Typography, Paper, Button, Grid, Divider } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/Atithiseva-Logo-Final-1024x298.png';
import { formatDateWithAmPm } from '../../Style';
import '../../styles/UserStyles.css';
import '../../styles/Payment.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBookingRequest } from '../../redux/Bookings/BookingAction';

function PaymentDetail() {
  const location = useLocation();
  const dispatch = useDispatch();
  const bookingId = location.state?.invoiceId;
  const navigate = useNavigate();
  const paymentDetails = useSelector((state) => state.booking?.booking?.data);
  console.log('paymentDetails', paymentDetails);
  useEffect(() => {
    dispatch(fetchBookingRequest(bookingId));
  }, [bookingId]);
  const currencyFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
  });
  if (!PaymentDetail)
    return <Typography>Invoice details not available.</Typography>;

  return (
    <Box className='payment-detail-container'>
      <Paper className='payment-detail-paper'>
        <Box className='payment-header'>
          <img src={Logo} alt='Atithiseva Logo' className='logo' />
          <Typography variant='h5' className='payment-header-title'>
            Invoice Detail
          </Typography>
        </Box>

        <Box className='payment-info-box'>
          <Typography variant='subtitle1'>
            Status :{' '}
            <span
              className={`payment-status ${
                paymentDetails?.payment_status === 1 ? 'completed' : 'pending'
              }`}
            >
              {paymentDetails?.payment_status === 1 ? 'completed' : 'Failed'}
            </span>
          </Typography>
        </Box>

        <Divider />

        <Box className='payment-details'>
          {[
            { label: 'Payment Id', value: paymentDetails.pnr_number },
            { label: 'Booking Id', value: paymentDetails.booking_serial_no },
            {
              label: 'Payment Date & Time',
              value: formatDateWithAmPm(paymentDetails?.created_at),
            },
            { label: 'Payment Method', value: 'UPI' },
            {
              label: 'Price',
              value: currencyFormatter.format(
                paymentDetails?.vendorBookLogs[0]?.length > 0
                  ? paymentDetails.vendorBookLogs[0]?.price
                  : paymentDetails.Order?.price
              ),
            },
            {
              label: 'CGST',
              value: currencyFormatter.format(
                paymentDetails?.vendorBookLogs[0]?.length > 0
                  ? paymentDetails.vendorBookLogs[0]?.cgst
                  : paymentDetails.Order?.cgst
              ),
            },
            {
              label: 'SGST',
              value: currencyFormatter.format(
                paymentDetails?.vendorBookLogs[0]?.length > 0
                  ? paymentDetails.vendorBookLogs[0]?.sgst
                  : paymentDetails.Order?.sgst
              ),
            },
            {
              label: 'TOTAL',
              value: currencyFormatter.format(
                paymentDetails?.vendorBookLogs[0]?.length > 0
                  ? paymentDetails.vendorBookLogs[0]?.total
                  : paymentDetails.Order?.total
              ),
            },
          ].map((item, index) => (
            <Grid container key={index} className='payment-grid'>
              <Grid item xs={6}>
                <Typography variant='body1' className='payment-label'>
                  {item.label}
                </Typography>
              </Grid>
              <Grid item xs={6} className='payment-value-container'>
                <Typography variant='body1' className='payment-value'>
                  {item.value}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>

        <Divider />

        <Box className='back-button-box'>
          <Button
            variant='contained'
            className='orange-button'
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default PaymentDetail;
